module.exports = {
	CRMURL: 'https://pea.sarvcrm.com'
};

